<template>
    <v-container fluid>
        <v-container>
            <v-skeleton-loader
                :loading="$apollo.queries.tenantSalesOrderCarts.loading"
                class="mb-6 elevation-2"
                type="article, list-item-three-line"
            >
                <div id="printMe" class="white pa-3">
                    <div
                        v-for="(salesOrderCart,index) in tenantSalesOrderCarts.edges"
                        :key="salesOrderCart.node.id"
                        :set="
                            (salesOrder = salesOrderCart
                                ? salesOrderCart.node.salesOrder
                                : {})
                        "
                    >
                        <v-row class="mx-1 align-center product-title">
                            <v-col>
                                <h2 class="title mt-n2 product-title">
                                    {{
                                        salesOrder.customer
                                            ? salesOrder.customer.name
                                            : ""
                                    }}
                                </h2>
                                <h3 class="font-weight-black">
                                    {{
                                        (salesOrder.orderLoadDate ||
                                            salesOrder.deliverDatePlanned)
                                            | moment(
                                                "utc",
                                                "dd, DD MMMM YYYY, HH:mm"
                                            )
                                    }}
                                </h3>
                                <p class="subtitle-1 font-weight-black" v-if="salesOrder.note">
                                    <i>
                                        <strong>{{ salesOrder.note }}</strong>
                                    </i>
                                </p>
                            </v-col>
                            <v-col>
                                <p
                                    style="text-align: center"
                                    class="mb-0 font-weight-black"
                                >
                                    <span class="mr-3"
                                        >Kar:
                                        {{ salesOrderCart.node.cartSeq }} /
                                        {{
                                            salesOrder.salesOrderCartSet
                                                ? salesOrder.salesOrderCartSet
                                                      .totalCount
                                                : ""
                                        }}</span
                                    >
                                    &nbsp;&nbsp;&nbsp;
                                    <span class="mr-3"
                                        >Type:
                                        {{
                                            salesOrderCart.node.externalCartType
                                        }}</span
                                    >&nbsp;&nbsp;&nbsp;
                                    <span class="mr-3"
                                        >Platen:
                                        {{
                                            salesOrderCart.node
                                                .externalLoosePlate
                                        }}</span
                                    >&nbsp;&nbsp;&nbsp;
                                    <span class="mr-3"
                                        >Veiling: {{ salesOrder.auction }}</span
                                    >
                                </p>
                                <div
                                    style="text-align: center"
                                    class="hidden-sm-and-down"
                                >
                                    <barcode
                                        v-bind:value="
                                            `LD-` +
                                                salesOrderCart.node
                                                    .externalSalesOrderCartId
                                        "
                                        format="CODE39"
                                        height="30"
                                        width="1"
                                        :text="salesOrder.salesOrderNo"
                                        >{{ salesOrder.salesOrderNo }}</barcode
                                    >
                                </div>
                                <div
                                    style="text-align: center"
                                    class="d-md-none no-print"
                                >
                                    <barcode
                                        v-bind:value="
                                            `LD-` +
                                                salesOrderCart.node
                                                    .externalSalesOrderCartId
                                        "
                                        format="CODE39"
                                        height="30"
                                        width="1"
                                        :text="salesOrder.salesOrderNo"
                                        >{{ salesOrder.salesOrderNo }}</barcode
                                    >
                                </div>
                            </v-col>
                        </v-row>

                        <div
                            v-for="cartItem in salesOrderCart
                                ? salesOrderCart.node.salesOrderProductCartSet
                                      .edges
                                : []"
                            :key="cartItem.node.id"
                            :set="
                                ((numOfConatiners =
                                    cartItem.node.quantity /
                                    cartItem.node.salesOrderProduct
                                        .quantityPerContainer),
                                (printPriority =
                                    cartItem.node.salesOrderProduct.product
                                        .printPriority != null
                                        ? cartItem.node.salesOrderProduct
                                              .product.printPriority
                                        : cartItem.node.salesOrderProduct
                                              .product.productCategory != null
                                        ? cartItem.node.salesOrderProduct
                                              .product.productCategory
                                              .printPriority
                                        : null))
                            "
                            class="product-border product-title"
                        >
                            <div class="product-title-container">
                                <!-- product title -->
                                <div>
                                    <h4>
                                        <v-icon
                                            v-if="cartItem.node.isReady"
                                            small
                                            class="mr-1 success--text no-print"
                                            >check_circle</v-icon
                                        >
                                        <v-icon
                                            v-else
                                            small
                                            class="mr-1 error--text no-print"
                                            >warning</v-icon
                                        >

                                        <span class="mr-2 product-title font-weight-black">{{
                                            cartItem.node.salesOrderProduct
                                                .product.name
                                        }}</span>
                                        <!-- Dynamic chip -->
                                        <!-- <v-chip
                                        v-if="!cartItem.node.salesOrderProduct.product.isDynamic"
                                        small
                                        outlined
                                        color="primary"
                                        >Dynamic</v-chip>-->
                                        <v-chip
                                            v-if="printPriority != null"
                                            small
                                            outlined
                                            class="font-weight-black no-print pl-1 pr-2"
                                            ><v-icon small class="left mr-1"
                                                >arrow_upward</v-icon
                                            >{{ printPriority }}</v-chip
                                        >
                                    </h4>
                                    <strong
                                        v-if="
                                            cartItem.node.salesOrderProduct.note
                                        "
                                        >**
                                        {{
                                            cartItem.node.salesOrderProduct.note
                                        }}
                                        **</strong
                                    >
                                </div>

                                <!-- product labels -->
                                <div>
                                    <table class="product-label-table">
                                        <tr>
                                            <th class="font-weight-black">Aantal</th>
                                            <th class="font-weight-black">Pot</th>
                                            <th class="font-weight-black">HG</th>
                                            <th class="font-weight-black">Fust</th>
                                            <!-- <th>ET</th>
                                            <th>HS</th>
                                            <th>ST</th>-->
                                        </tr>
                                        <tr>
                                            <td
                                                class="text-center product-title-label font-weight-black"
                                            >
                                                {{ numOfConatiners }} x
                                                {{
                                                    cartItem.node
                                                        .salesOrderProduct
                                                        .quantityPerContainer
                                                }}
                                            </td>
                                            <td
                                                class="text-center product-title-label font-weight-black"
                                            >
                                                {{
                                                    cartItem.node
                                                        .salesOrderProduct
                                                        .product.externalPotsize
                                                }}
                                            </td>
                                            <td
                                                class="text-center product-title-label font-weight-black"
                                            >
                                                {{
                                                    cartItem.node
                                                        .salesOrderProduct
                                                        .product.externalHeight
                                                }}
                                            </td>
                                            <td
                                                class="text-center product-title-label font-weight-black"
                                            >
                                                {{
                                                    cartItem.node
                                                        .salesOrderProduct
                                                        .externalContainer
                                                }}
                                            </td>
                                            <!-- <td
                                                class="text-center"
                                            >{{ cartItem.node.salesOrderProduct.product.externalLabel }}</td>
                                            <td
                                                class="text-center"
                                            >{{ cartItem.node.salesOrderProduct.product.externalCover }}</td>
                                            <td
                                                class="text-center"
                                            >{{ cartItem.node.salesOrderProduct.product.externalSticker }}</td>-->
                                        </tr>
                                    </table>
                                </div>
                            </div>

                            <hr class="dashed" />

                            <!-- plants -->
                            <div>
                                <!-- if dynammic product plants are NOT selected, show all optional plants -->
                                <table
                                    class="plants-table"
                                    v-if="
                                        cartItem.node.salesOrderProduct.product
                                            .isDynamic &&
                                            cartItem.node.salesOrderProduct
                                                .salesOrderPlantSet.edges
                                                .length == 0
                                    "
                                >
                                    <tr>
                                        <th
                                            class="text-left font-weight-black"
                                            style="width: 5%"
                                        ></th>
                                        <th
                                            class="text-left product-title"
                                            style="width: 43%"
                                        >
                                            Plant
                                        </th>
                                        <th class="font-weight-black">Aantal</th>
                                        <!-- <th>Pot</th> -->
                                        <th class="font-weight-black">Color</th>
                                        <th class="no-print font-weight-black">Environment</th>
                                        <th class="font-weight-black">Tag</th>
                                    </tr>
                                    <tr
                                        v-for="productItem in cartItem.node
                                            .salesOrderProduct.product
                                            .productItemSet.edges"
                                        :key="productItem.node.id"
                                        class="body product-title"
                                    >
                                        <td>
                                            <v-icon
                                                >check_box_outline_blank</v-icon
                                            >
                                        </td>
                                        <td class="text-left">
                                            <b>{{ productItem.node.plant.name }}</b>
                                        </td>
                                        <td class="text-center">
                                            <div class="underline"></div>
                                        </td>
                                        <!-- <td
                                    class="text-center"
                                        >{{ productItem.node.potSize ? productItem.node.potSize.potSizeCm : "-" }} cm</td>-->
                                        <td class="text-center font-weight-black">
                                            <b>{{
                                                productItem.node.color
                                                    ? productItem.node.color
                                                          .color
                                                    : "-"
                                            }}</b>
                                        </td>
                                        <td class="text-center no-print product-title">
                                            {{
                                                productItem.node.environment
                                                    ? productItem.node
                                                          .environment
                                                          .environment
                                                    : "-"
                                            }}
                                        </td>
                                        <td class="text-center product-title">
                                            {{
                                                productItem.node.tag
                                                    ? productItem.node.tag.tag
                                                    : "-"
                                            }}
                                        </td>
                                    </tr>
                                </table>

                                <!-- if dynammic product plants are selected, show selected plants -->
                                <table
                                    class="plants-table"
                                    v-else-if="
                                        cartItem.node.salesOrderProduct.product
                                            .isDynamic &&
                                            cartItem.node.salesOrderPlantCartSet
                                                .edges.length > 0
                                    "
                                >
                                    <tr>
                                        <th
                                            class="text-left product-title"
                                            style="width: 48%"
                                        >
                                            Plant
                                        </th>
                                        <th class="product-title">Aantal</th>
                                        <!-- <th>Pot</th> -->
                                        <th>Color</th>
                                        <th class="no-print product-title">Environment</th>
                                        <th>Tag</th>
                                    </tr>
                                    <tr
                                        v-for="productItem in cartItem.node
                                            .salesOrderPlantCartSet.edges"
                                        :key="productItem.node.id"
                                        :set="
                                            (plantQuantityMod =
                                                productItem.node.quantity %
                                                numOfConatiners)
                                        "
                                        class="body"
                                    >
                                        <td class="text-left">
                                            {{
                                                productItem.node.salesOrderPlant
                                                    .plant.name
                                            }}
                                        </td>
                                        <!-- if single plant container, directly show plant quantity -->
                                        <td
                                            v-if="
                                                cartItem.node.salesOrderProduct
                                                    .quantityPerContainer == 1
                                            "
                                            class="text-center"
                                        >
                                            {{ productItem.node.quantity }} x 1
                                        </td>
                                        <!-- else if can be divided, show numOfContainers x plantQuantityPerContainer -->
                                        <td
                                            v-else-if="plantQuantityMod == 0"
                                            class="text-center"
                                        >
                                            {{ numOfConatiners }} x
                                            {{
                                                productItem.node.quantity /
                                                    numOfConatiners
                                            }}
                                        </td>
                                        <!-- else directly show plantQuantity -->
                                        <td v-else class="text-center">
                                            {{ productItem.node.quantity }}
                                        </td>
                                        <!-- <td
                                    class="text-center"
                                        >{{ productItem.node.salesOrderPlant.potSize ? productItem.node.salesOrderPlant.potSize.potSizeCm : "-" }} cm</td>-->
                                        <td class="text-center">
                                            {{
                                                productItem.node.salesOrderPlant
                                                    .color
                                                    ? productItem.node
                                                          .salesOrderPlant.color
                                                          .color
                                                    : "-"
                                            }}
                                        </td>
                                        <td class="text-center no-print">
                                            {{
                                                productItem.node.salesOrderPlant
                                                    .environment
                                                    ? productItem.node
                                                          .salesOrderPlant
                                                          .environment
                                                          .environment
                                                    : "-"
                                            }}
                                        </td>
                                        <td class="text-center">
                                            {{
                                                productItem.node.salesOrderPlant
                                                    .tag
                                                    ? productItem.node
                                                          .salesOrderPlant.tag
                                                          .tag
                                                    : "-"
                                            }}
                                        </td>
                                    </tr>
                                </table>

                                <!-- static product plants -->
                                <table
                                    class="plants-table"
                                    v-else-if="
                                        cartItem.node.salesOrderProduct.product
                                            .productItemSet.edges.length > 1
                                    "
                                >
                                    <tr>
                                        <th
                                            class="text-left"
                                            style="width: 48%"
                                        >
                                            Plant
                                        </th>
                                        <th>Aantal</th>
                                        <!-- <th>Pot</th> -->
                                        <th>Color</th>
                                        <th class="no-print">Environment</th>
                                        <th>Tag</th>
                                    </tr>
                                    <tr
                                        v-for="productItem in cartItem.node
                                            .salesOrderPlantCartSet.edges"
                                        :key="productItem.node.id"
                                        class="body"
                                    >
                                        <td class="text-left">
                                            {{
                                                productItem.node.salesOrderPlant
                                                    .plant.name
                                            }}
                                        </td>
                                        <td class="text-center">
                                            {{ productItem.node.quantity }}
                                        </td>
                                        <!-- <td
                                    class="text-center"
                                        >{{ productItem.node.salesOrderPlant.potSize ? productItem.node.salesOrderPlant.potSize.potSizeCm : "-" }} cm</td>-->
                                        <td class="text-center">
                                            {{
                                                productItem.node.salesOrderPlant
                                                    .color
                                                    ? productItem.node
                                                          .salesOrderPlant.color
                                                          .color
                                                    : "-"
                                            }}
                                        </td>
                                        <td class="text-center no-print">
                                            {{
                                                productItem.node.salesOrderPlant
                                                    .environment
                                                    ? productItem.node
                                                          .salesOrderPlant
                                                          .environment
                                                          .environment
                                                    : "-"
                                            }}
                                        </td>
                                        <td class="text-center">
                                            {{
                                                productItem.node.salesOrderPlant
                                                    .tag
                                                    ? productItem.node
                                                          .salesOrderPlant.tag
                                                          .tag
                                                    : "-"
                                            }}
                                        </td>
                                    </tr>
                                </table>
                            </div>
                        </div>
                        <div v-if="(index<tenantSalesOrderCarts.edges.length-1)" class="page-break"></div>
                    </div>
                </div>
            </v-skeleton-loader>
        </v-container>
    </v-container>
</template>

<script>
import gql from "graphql-tag";
import VueBarcode from "vue-barcode";

export default {
    name: "order-cart-preview-list",
    props: ["salesOrderCartNodeIdList", "loading"],
    components: {
        barcode: VueBarcode
    },

    apollo: {
        tenantSalesOrderCarts: {
            query: gql`
                query tenantSalesOrderCarts($ids: [ID]) {
                    tenantSalesOrderCarts(
                        id: $ids
                        first: 100
                        orderBy: "cartSeq"
                    ) {
                        edges {
                            node {
                                id
                                externalSalesOrderCartId
                                cartSeq
                                externalCartType
                                externalLoosePlate
                                externalAuction
                                salesOrder {
                                    id
                                    salesOrderNo
                                    note
                                    auction
                                    deliverDatePlanned
                                    orderLoadDate
                                    customer {
                                        id
                                        name
                                    }
                                    salesOrderCartSet {
                                        totalCount
                                    }
                                }
                                salesOrderProductCartSet {
                                    edges {
                                        node {
                                            id
                                            quantity
                                            isReady
                                            salesOrderPlantCartSet {
                                                edges {
                                                    node {
                                                        id
                                                        quantity
                                                        salesOrderPlant {
                                                            id
                                                            plant {
                                                                id
                                                                name
                                                            }
                                                            color {
                                                                id
                                                                color
                                                            }
                                                            potSize {
                                                                id
                                                                potSizeCm
                                                            }
                                                            environment {
                                                                id
                                                                environment
                                                            }
                                                            tag {
                                                                id
                                                                tag
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                            salesOrderProduct {
                                                id
                                                note
                                                quantityPerContainer
                                                externalContainer
                                                product {
                                                    id
                                                    name
                                                    isDynamic
                                                    externalCover
                                                    externalHeight
                                                    externalLabel
                                                    externalPotsize
                                                    externalSticker
                                                    printPriority
                                                    productCategory {
                                                        id
                                                        printPriority
                                                    }
                                                    productItemSet {
                                                        edges {
                                                            node {
                                                                id
                                                                plant {
                                                                    id
                                                                    name
                                                                }
                                                                potSize {
                                                                    id
                                                                    potSizeCm
                                                                }
                                                                color {
                                                                    id
                                                                    color
                                                                }
                                                                environment {
                                                                    id
                                                                    environment
                                                                }
                                                                tag {
                                                                    id
                                                                    tag
                                                                }
                                                                numPlants
                                                            }
                                                        }
                                                    }
                                                }
                                                salesOrderPlantSet {
                                                    edges {
                                                        node {
                                                            id
                                                            quantity
                                                            numPlantsPerProduct
                                                            productItem {
                                                                id
                                                            }
                                                            plant {
                                                                id
                                                                name
                                                            }
                                                            potSize {
                                                                id
                                                                potSizeCm
                                                            }
                                                            color {
                                                                id
                                                                color
                                                            }
                                                            environment {
                                                                id
                                                                environment
                                                            }
                                                            tag {
                                                                id
                                                                tag
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            `,
            variables() {
                return {
                    ids: this.salesOrderCartNodeIdList
                };
            },
            // Additional options here
            fetchPolicy: "cache-and-network",
            update(data) {
                // console.log(data.tenantSalesOrderCarts);

                data.tenantSalesOrderCarts.edges.map(item => {
                    item.node.salesOrderProductCartSet.edges.sort(function(
                        a,
                        b
                    ) {
                        var aPrintPriority =
                            a.node.salesOrderProduct.product.printPriority !=
                            null
                                ? a.node.salesOrderProduct.product.printPriority
                                : a.node.salesOrderProduct.product
                                      .productCategory != null &&
                                  a.node.salesOrderProduct.product
                                      .productCategory.printPriority != null
                                ? a.node.salesOrderProduct.product
                                      .productCategory.printPriority
                                : 999999999999;
                        var bPrintPriority =
                            b.node.salesOrderProduct.product.printPriority !=
                            null
                                ? b.node.salesOrderProduct.product.printPriority
                                : a.node.salesOrderProduct.product
                                      .productCategory != null &&
                                  b.node.salesOrderProduct.product
                                      .productCategory.printPriority != null
                                ? b.node.salesOrderProduct.product
                                      .productCategory.printPriority
                                : 999999999999;

                        if (aPrintPriority < bPrintPriority) {
                            return -1;
                        }

                        if (aPrintPriority > bPrintPriority) {
                            return 1;
                        }

                        return 0;
                    });
                });

                //send data to parent component
                this.$emit("item-fetched", data.tenantSalesOrderCarts);

                // console.log(data.tenantSalesOrderCarts);

                // this.$emit("update:loading", false);

                //return result to current componet
                return data.tenantSalesOrderCarts;
            },
            watchLoading(isLoading) {
                this.$emit("update:loading", isLoading);
                // isLoading is a boolean
                // countModifier is either 1 or -1
            },
            skip() {
                return this.salesOrderCartNodeIdList.length === 0;
            },
            pollInterval: 60000 // ms
        }
    },

    data() {
        return {
            // isLoadingOrder: false,
            tenantSalesOrderCarts: []
        };
    },
    computed: {
        // salesOrder() {
        //     return this.salesOrderCart.salesOrder || {};
        // },
        // orderCartProducts() {
        //     return this.salesOrderCart.salesOrderProductCartSet
        //         ? this.salesOrderCart.salesOrderProductCartSet.edges
        //         : [];
        // },
        isLoading() {
            return this.$apollo.queries.tenantSalesOrderCarts.loading;
        }
    },
    watch: {},
    created() {
        // this.initialize();
    },
    mounted() {},
    methods: {
        // initialize() {
        //     this.fetchSingleOrder();
        //     // this.fetchGreenhouseDepartmentSections();
        // },
        // fetchSingleOrder() {
        //     this.isLoadingOrder = true;
        //     this.$store
        //         .dispatch("sales/fetchSingleSalesOrder", this.$route.params.id)
        //         .then(response => {
        //             // console.log(response);
        //             this.order = response;
        //             this.isLoadingOrder = false;
        //         })
        //         .catch(error => {
        //             /*handle errors*/
        //             console.log(error);
        //             this.isLoadingOrder = false;
        //         })
        //         .finally();
        // },
        // print() {
        //     // Pass the element id here
        //     this.$htmlToPaper("printMe", null, () => {
        //         console.warn("Print done");
        //     });
        // }
    }
};
</script>

<style scoped>
@media all {
    .page-break {
        display: none;
    }
}

@media print {
    .no-print,
    .no-print * {
        display: none !important;
    }

    .page-break {
        display: block;
        page-break-before: always;
    }
}
hr.dashed {
    border-top: dashed;
    border-width: 1px;
    margin-left: 10px;
    margin-right: 10px;
}
.product-border {
    border-top: double;
    margin-bottom: 30px;
}
.product-title-container {
    display: grid;
    grid-auto-columns: 1fr;
    grid-auto-flow: column;
    grid-gap: 20px;
    padding: 10px;
}
.product-title {
    font-weight: bold;
}
.product-title-label {
    font-weight: bold;
}
table.product-label-table {
    table-layout: fixed;
    width: 100%;
}
table.plants-table {
    margin-top: 10px;
    margin-left: 10px;
    table-layout: fixed;
    width: 100%;
}
tr.body {
    height: 20px;
}
th.text-center {
    text-align: center;
}
th.text-left {
    text-align: left;
}
th.text-right {
    text-align: right;
}
th.text-justify {
    text-align: justify;
}
td.text-center {
    text-align: center;
}
td.text-left {
    text-align: left;
}
td.text-right {
    text-align: right;
}
td.text-justify {
    text-align: justify;
}
.underline {
    text-align: justify;
    border-bottom: 1px solid black;
    margin-left: 30px;
    margin-right: 30px;
    margin-top: 20px;
}
</style>